import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {LayerWithWorkingProps} from 'common/src/modules/movieEditor/movieEditor.types';
import updateComps from './updateComps';
import {RootState} from 'common/src/redux/store';

interface UpdateLayerParams {
  compId?: string;
  layerId: string;
  data: Partial<LayerWithWorkingProps>;
  activeFormat?: string;
  replaceState?: boolean;
}

const updateLayer = createAsyncThunk(
  `${BreadcrumbName.AdBuilder}/updateLayer`,
  async (
    {compId, layerId, data, activeFormat, replaceState = false}: UpdateLayerParams,
    {dispatch, getState},
  ): Promise<void> => {
    const state = getState() as RootState;
    const workingCompId = compId || state.creativeTemplatePage.formatMovies.activeCompId;

    await dispatch(
      updateComps({
        compsUpdate: (oldComps) => {
          const newLayers = [...oldComps[workingCompId].l];
          const idx = newLayers.findIndex((layer) => layer.id === layerId);

          if (newLayers[idx] && newLayers[idx].isLocked && data.isLocked !== false) {
            return oldComps;
          }

          newLayers[idx] = {
            ...newLayers[idx],
            ...data,
          } as LayerWithWorkingProps;

          return {
            ...oldComps,
            [workingCompId]: {
              ...oldComps[workingCompId],
              l: newLayers,
            },
          };
        },
        activeFormat,
        replaceState,
      }),
    );
  },
);

export default updateLayer;
